import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProjectionModule } from '@shared/core/components/projection';

import { OnlineMenuNavTypesModule } from './onlineMenuNavTypes';

import { OnlineMenuNavComponent } from './online-menu-nav.shared.component';

@NgModule({
    declarations: [
        OnlineMenuNavComponent,
    ],
    imports: [
        CommonModule,
        OnlineMenuNavTypesModule,
        ProjectionModule,
    ],
    exports: [
        OnlineMenuNavComponent,
    ],
})
export class OnlineMenuNavModule { }
